"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableStyled = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../constants/themeContants");

var _theming = require("../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Table =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, _getPrototypeOf(Table).apply(this, arguments));
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          blacklist = _this$props.blacklist,
          mapHeader = _this$props.mapHeader,
          children = _this$props.children,
          variant = _this$props.variant,
          itemToKey = _this$props.itemToKey,
          onHeaderClick = _this$props.onHeaderClick,
          renderHeader = _this$props.renderHeader,
          overrideHeaders = _this$props.overrideHeaders,
          restProps = _objectWithoutProperties(_this$props, ["data", "blacklist", "mapHeader", "children", "variant", "itemToKey", "onHeaderClick", "renderHeader", "overrideHeaders"]);

      var headers = overrideHeaders ? overrideHeaders.map(function (header) {
        return {
          value: header,
          title: header
        };
      }).map(mapHeader) : data.reduce(function (acc, current) {
        Object.keys(current).forEach(function (key) {
          if (!acc.includes(key)) {
            acc.push(key);
          }
        });
        return acc;
      }, []).filter(blacklist).map(function (header) {
        return {
          value: header,
          title: header
        };
      }).map(mapHeader);
      return _react["default"].createElement(TableStyled, _extends({
        variant: variant
      }, restProps), _react["default"].createElement("thead", null, _react["default"].createElement("tr", null, headers.map(function (item, index) {
        if (renderHeader) {
          return renderHeader({
            item: item,
            index: index
          });
        }

        return _react["default"].createElement("th", {
          key: "thead-".concat(item.value),
          onClick: function onClick(e) {
            return onHeaderClick(e, item);
          }
        }, item.title);
      }))), _react["default"].createElement("tbody", null, this.props.data.map(function (item, index) {
        var key = itemToKey(item);
        return _react["default"].createElement("tr", {
          key: "tr-".concat(typeof key === "string" ? key : index)
        }, children({
          item: item,
          headers: headers,
          index: index
        }));
      })));
    }
  }]);

  return Table;
}(_react["default"].Component);

Table.themeProps = {
  table: {
    name: "base-component-table",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var TableStyled = _styledComponents["default"].table.withConfig({
  displayName: "Table__TableStyled",
  componentId: "sc-18722ea-0"
})(["", ";"], (0, _theming.applyVariants)(Table.themeProps.table));

exports.TableStyled = TableStyled;
Table.propTypes = {
  blacklist: _propTypes["default"].func,
  children: _propTypes["default"].func.isRequired,
  data: _propTypes["default"].array.isRequired,
  fallbackCellValue: _propTypes["default"].any,
  itemToKey: _propTypes["default"].any,
  mapHeader: _propTypes["default"].func,
  onHeaderClick: _propTypes["default"].func,
  renderHeader: _propTypes["default"].func,
  overrideHeaders: _propTypes["default"].array
};
var _default = Table;
exports["default"] = _default;
Table.defaultProps = {
  blacklist: function blacklist(item) {
    return item;
  },
  data: [{
    name: "one"
  }, {
    name: "two",
    lol: "omg"
  }],
  fallbackCellValue: "n/a",
  itemToKey: function itemToKey(item) {
    return item;
  },
  mapHeader: function mapHeader(item) {
    return item;
  },
  onHeaderClick: console.log
};